import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { GetRotationPlanById, UpdateRotationPlan } from '../../../../store/HR/Raqeeb/raqeebSlice';
import DaysCard from './DaysCard';
import validationSchema from '../validationSchema';
import useInitialValues from './useInitialValues';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import { Fade } from 'react-awesome-reveal';

function RotationSetting() {
  const { HasPermission } = usePermissions();
  const { id } = useParams();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { initialValues, data, loading, error } = useInitialValues();

  const createDayObject = (day) => ({
    startIn: day.startIn,
    endOut: day.endOut,
    fingerprintTime1: day.fingerprintTime1,
    fingerprintTime2: day.fingerprintTime2,
    duration1: day.duration1,
    fingerprintTime3: day.fingerprintTime3,
    fingerprintTime4: day.fingerprintTime4,
    // duration2: day.duration2,
    allowIn:
      day.isFlexible === true || ['0', '1'].includes(day.countFingerprint)
        ? 0
        : Number(day.allowIn),
    allowOut:
      day.isFlexible === true || ['0', '1'].includes(day.countFingerprint)
        ? 0
        : Number(day.allowOut),
    countFingerprint: Number(day.countFingerprint),
    isExtraDay: ['1', '0'].includes(day.countFingerprint) ? false : day.isExtraDay,
    isFlexible: ['1', '0'].includes(day.countFingerprint) ? false : day.isFlexible,
    startFlexible: day.isFlexible === false ? 0 : Number(day.startFlexible),
    endFlexible: day.isFlexible === false ? 0 : Number(day.endFlexible),
    startIn2: day.startIn2,
    endOut2: day.endOut2,
    // duratioN2: day.duratioN2,
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema(t),

    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(
        UpdateRotationPlan({
          raqRotationPlansDto: {
            id: id,
            // businessGroupId: ,
            name: values.raqRotationPlan.name,
            name2: values.raqRotationPlan.name2,
            startDate: values.raqRotationPlan.startDate,
            endDate: values.raqRotationPlan.endDate,
            description: values.raqRotationPlan.description,
            // allowIn: values.raqRotationPlan.allowIn,
            // allowOut: values.raqRotationPlan.allowOut,
            // count_Fingerprint: values.raqRotationPlan.count_Fingerprint,
          },

          sat: createDayObject(values.sat),
          sun: createDayObject(values.sun),
          mon: createDayObject(values.mon),
          tue: createDayObject(values.tue),
          wed: createDayObject(values.wed),
          thu: createDayObject(values.thu),
          fri: createDayObject(values.fri),
        })
      )
        .unwrap()
        .then((res) => {
          debugger;
          if (res.succeeded) {
            CustomAlert({ action: 'Edit' });
            Navigate(-1, { replace: true });
            dispatch(GetRotationPlanById(id));
          } else {
            CustomAlert({ action: 'Error', msg: res.message });
          }
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    },
  });

  // __________________________
  const copyDayData = (sourceDay) => {
    const sourceData = formik.values[sourceDay];
    const updatedValues = { ...formik.values };

    const days = ['sat', 'sun', 'mon', 'tue', 'wed', 'thu', 'fri'];
    days.forEach((day) => {
      if (day !== sourceDay) {
        updatedValues[day] = { ...sourceData };
      }
    });

    formik.setValues(updatedValues);
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome',
            },
            {
              name: t('RotationPlan'),
              link: '/RAQ/RotationPlan',
            },
            {
              name: t('PlanSettings'),
              link: null,
            },
          ]}
          PageName={t('RotationPlanSettings')}
          subtitle={
            i18n.language === 'en'
              ? data?.raqRotationPlansDto?.name
              : data?.raqRotationPlansDto?.name2
          }
        />

        <div className="ms-auto">
          {HasPermission('EditRaqRotationPlans') && (
            <button
              disabled={formik.isSubmitting}
              type="button"
              className="btn btn-lg me-1 btn-theme mb-1   rounded-1"
              onClick={formik.submitForm}>
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fa fa-save fa-fw me-2"></i>
              )}
              {t('Save')}
            </button>
          )}
          <button
            type="button"
            className=" btn btn-lg me-1 btn-default mb-1   rounded-1"
            onClick={() => Navigate(-1, { replace: true })}>
            <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
          </button>
        </div>
      </div>

      <Form onSubmit={formik.handleSubmit}>
        <Card>
          <Loading loading={loading} error={error}>
            <CardBody>
              <div className="row">
                <div className="col-xl-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('LocalName')}</label>
                    <Form.Control
                      className="form-control"
                      type="text"
                      autoComplete="off"
                      name="raqRotationPlan.name2"
                      onChange={formik.handleChange}
                      value={formik.values.raqRotationPlan.name2 || ''}
                      isInvalid={
                        formik.errors?.raqRotationPlan?.name2 &&
                        formik.touched?.raqRotationPlan?.name2
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors?.raqRotationPlan?.name2}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className="col-xl-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('GlobalName')}</label>
                    <Form.Control
                      className="form-control"
                      type="text"
                      autoComplete="off"
                      name="raqRotationPlan.name"
                      onChange={formik.handleChange}
                      value={formik.values.raqRotationPlan.name || ''}
                      isInvalid={
                        formik.errors?.raqRotationPlan?.name &&
                        formik.touched?.raqRotationPlan?.name
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors?.raqRotationPlan?.name2}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className="col-xl-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('Date_from')}</label>
                    <Form.Control
                      type="date"
                      className="form-c ontrol"
                      name="raqRotationPlan.startDate"
                      onChange={formik.handleChange}
                      value={formik.values.raqRotationPlan.startDate || ''}
                      isInvalid={
                        formik.errors?.raqRotationPlan?.startDate &&
                        formik.touched?.raqRotationPlan?.startDate
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors?.raqRotationPlan?.startDate}
                    </Form.Control.Feedback>
                  </div>
                </div>

                <div className="col-xl-3">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('Date_TO')}</label>
                    <Form.Control
                      type="date"
                      className="form-c ontrol"
                      name="raqRotationPlan.endDate"
                      onChange={formik.handleChange}
                      value={formik.values.raqRotationPlan.endDate || ''}
                      isInvalid={
                        formik.errors?.raqRotationPlan?.endDate &&
                        formik.touched?.raqRotationPlan?.endDate
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors?.raqRotationPlan?.endDate}
                    </Form.Control.Feedback>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('Note')}</label>
                    <Form.Control
                      className="form-control"
                      as="textarea"
                      rows={3}
                      name="raqRotationPlan.description"
                      onChange={formik.handleChange}
                      value={formik.values.raqRotationPlan.description || ''}
                    />
                    <div></div>
                  </div>
                </div>
              </div>

              <div className="row g-4 d-flex align-items-stretch">
                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Saturday')} day="sat" formik={formik} />
                    {/* <div className="row mt-3">
                      <div className="col-xl-12">
                        <button
                          type="button"
                          onClick={() => copyDayData('sat')}
                          className=" btn btn-lg me-1 btn-default mb-1   rounded-1">
                          نسخ بيانات السبت إلى بقية الأيام
                        </button>
                      </div>
                    </div> */}
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Sunday')} day="sun" formik={formik} />
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Monday')} day="mon" formik={formik} />
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Tuesday')} day="tue" formik={formik} />
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Wednesday')} day="wed" formik={formik} />
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Thursday')} day="thu" formik={formik} />
                  </Fade>
                </div>

                <div className="col-xl-6">
                  <Fade triggerOnce={true}>
                    <DaysCard dayName={t('Friday')} day="fri" formik={formik} />
                  </Fade>
                </div>
              </div>
            </CardBody>
          </Loading>
        </Card>
      </Form>
    </>
  );
}

export default RotationSetting;
